import React from "react";
import styles from "./OriChatStarterPills.module.scss";

export interface StarterPillItem {
  key: string;
  label: string;
  testId: string;
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
}

interface OriStarterPillRowProps {
  items: StarterPillItem[];
  testId: string;
  onSelect: (index: number) => void;
  disabled: boolean;
}

const OriStarterPillRow: React.FC<OriStarterPillRowProps> = ({
  items,
  testId,
  onSelect,
  disabled,
}) => (
  <div className={styles.pills} data-testid={testId}>
    {items.map(({ key, label, testId: itemTestId, Icon }, index) => (
      <button
        key={key}
        type="button"
        className={styles.pill}
        data-testid={itemTestId}
        disabled={disabled}
        onClick={() => onSelect(index)}
      >
        {Icon && <Icon className={styles.icon} aria-hidden focusable={false} />}
        {label}
      </button>
    ))}
  </div>
);

export default OriStarterPillRow;
